// extracted by mini-css-extract-plugin
export default {"about":"about_fRWHj"};